import DefaultMainPage from "../../pages/DefaultMainPage";
import Message from "./Message";

const messageMenuItems = [
    {path: "/message", component: <Message/>,  label: '푸쉬 관리'},
];

export const pushRoutes = {
    path: "/message",
    component: <DefaultMainPage buttons={messageMenuItems}/>,
    
    children: messageMenuItems
}